<template>
  <div id="index">
    <Header></Header>
    <Search></Search>
    <Nav></Nav>
    <div class="content">
      <div class="w index-content">
        <template v-if="template_list.length">
          <template v-for="(item, index) in template_list">
            <banner :param="item.param" v-if="item.type == 'banner'"></banner>

            <template v-if="item.type == 'banner'">
              <div class="invitation">
                <div class="invitation_head d-flex">
                  <div class="invitation_title">招标公告</div>
                  <div
                    class="invitation_more d-flex align-items-center"
                    @click.stop="invita_more"
                  >
                    查看更多
                  </div>
                </div>
                <el-table style="width: 100%" :data="bidTable" class="bidtable">
                  <el-table-column
                    prop="title"
                    label="项目标题"
                    min-width="220"
                  >
                    <template slot-scope="scope">
                      <div class="project"  @click.stop="tender(scope.row.id)">
                        <div class="project_head">
                          <p class="gongshi">公示</p>
                          <p class="title show-one-lines">
                            {{ scope.row.title }}
                          </p>
                        </div>
                        <div class="label">
                          标签：<span>{{ scope.row.label }}</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="采购商"
                    min-width="130"
                  ></el-table-column>

                  <el-table-column
                    prop="cutTime"
                    label="截止时间"
                    sortable
                    min-width="130"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="cutoff">
                        剩余<span>{{ scope.row.residue_time }}</span
                        >天
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="招标状态">
                    <template slot-scope="scope">
                      <div class="cutoff">
                        <span v-if="scope.row.status == 1">进行中</span>
                        <span v-else-if="scope.row.status == 2">已结束</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
            <!-- 商品广告位 -->
            <adsense
              :param="item.param"
              v-if="item.type == 'adsense'"
            ></adsense>
            <miaosha
              :param="item.param"
              v-if="item.type == 'miaosha'"
            ></miaosha>
            <!-- 特价商品 -->
            <special
              :param="item.param"
              v-if="item.type == 'special'"
            ></special>
            <!-- 排行榜 -->
            <goodsRanking
              :param="item.param"
              v-if="item.type == 'goodsRanking'"
            ></goodsRanking>
            <!-- 新品 -->
            <news :param="item.param" v-if="item.type == 'new'"></news>
            <!-- 品牌推荐 -->
            <brand :param="item.param" v-if="item.type == 'brand'"></brand>
            <!-- 热销商品 -->
            <hot :param="item.param" v-if="item.type == 'hot'"></hot>
            <!-- 好物推荐 -->
            <fine :param="item.param" v-if="item.type == 'fine'"></fine>
            <!-- 特色推荐1 -->
            <feature1
              :param="item.param"
              v-if="item.type == 'feature1'"
            ></feature1>
            <!-- 特色推荐2 -->
            <feature2
              :param="item.param"
              v-if="item.type == 'feature2'"
            ></feature2>
            <!-- 实力商家 -->
            <store
              :param="item.param"
              v-if="item.type == 'storeRanking'"
            ></store>
            <!-- 频道广场 -->
            <channel
              :param="item.param"
              v-if="item.type == 'channel'"
            ></channel>
            <!-- 猜你喜欢 -->
            <like :param="item.param" v-if="item.type == 'like'"></like>
            <!-- 楼层 -->
            <floor
              :param="item.param"
              v-if="item.type == 'floor'"
              :id="index"
            ></floor>
            <!-- 广告位 -->
            <seat
              :param="item.param"
              :index="index"
              v-if="item.type == 'seat'"
            ></seat>
          </template>
        </template>
        <div class="floor">
          <template v-for="(item, index) in template_list">
            <template v-if="item.type == 'floor'">
              <div
                class="floor-item"
                :class="{ active: floor_active == index }"
                @click="floorClick(index)"
                v-text="item.param.floor_title || item.param.title"
              ></div>
            </template>
          </template>
        </div>
        <div class="back-top" :class="{ active: scroll_top }" @click="backTop">
          Top
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
let timeFun = null;
import Header from "@/components/header/header";
import Search from "@/components/search/search";
import Nav from "@/components/nav/nav";
import Foot from "@/components/foot/foot";
import banner from "./components/banner";
import adsense from "./components/adsense";
import miaosha from "./components/seckill"; //秒杀
import special from "./components/special";
import goodsRanking from "./components/goodsRanking";
import news from "./components/new";
import brand from "./components/brand";
import hot from "./components/hot";
import feature1 from "./components/feature1";
import feature2 from "./components/feature2";
import fine from "./components/fine";
import channel from "./components/channel";
import like from "./components/like";
import store from "./components/store";
import floor from "./components/floor";
import seat from "./components/seat";
// import cookie from 'js-cookie'
export default {
  components: {
    Search,
    Header,
    Nav,
    Foot,
    banner,
    miaosha,
    adsense,
    special,
    goodsRanking,
    news,
    brand,
    hot,
    feature1,
    feature2,
    fine,
    channel,
    like,
    store,
    floor,
    seat,
  },
  data() {
    return {
      template_list: [], //diy返回模块
      scroll_top: false,
      floor_active: -1,
      bidTable: [],
    };
  },
  created() {
    this.getData();
    this.getBidList();
    // let cookieList=document.cookie;
    // console.log(cookie.getJSON())
  },
  mounted() {
    let that = this;
    window.onscroll = function () {
      let scroll_top =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll_top >= 400) {
        that.scroll_top = true;
      } else {
        that.scroll_top = false;
      }
      let floot_list = document.getElementsByClassName("floor-box");
      for (let i = 0; i < floot_list.length; i++) {
        // if(scroll_top >= floot_list[i].offsetTop+165){原来的}
        if (scroll_top >= floot_list[i].offsetTop - 100) {
          that.floor_active = floot_list[i].parentNode.id;
        }
      }
    };
  },
  methods: {
    getData() {
      this.$loading();
      this.$api
        .index()
        .then((res) => {
          if (res.code == 0) {
            this.$loading().close();
            this.template_list = res.data.template;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
    backTop() {
      this.common.backTop(20);
    },
    floorClick(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      /* clearInterval(timeFun)
				timeFun = setInterval(()=> {
					let offset_top = document.getElementById(id).offsetTop+186;
					let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
					if(offset_top>scroll_top){
						document.documentElement.scrollTop = document.body.scrollTop = scroll_top+(offset_top/100);
						if (scroll_top >= offset_top) {
							document.documentElement.scrollTop = document.body.scrollTop = offset_top;
							clearInterval(timeFun);
						}
					}else{
						document.documentElement.scrollTop = document.body.scrollTop = scroll_top-(offset_top/100);
						if (scroll_top <= offset_top) {
							document.documentElement.scrollTop = document.body.scrollTop = offset_top;
							clearInterval(timeFun);
						}
					}
				}, 5) */
    },
    // 获取招标列表
    getBidList() {
      let that = this;
      let params = {
        page: 1,
        limit: 4,
      };
      this.$api
        .callList(params)
        .then((res) => {
          if (res.code == 0) {
            that.bidTable = res.data.list;
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    invita_more() {
      this.$router.push({
        path: "/invitation",
      });
    },
    
    // 立即投标
    tender(id) {
      let that=this;
      if (!this.$store.state.user) {
        this.$confirm('您还未登录，请您前往登录','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning',
            
        }).then(()=>{
          that.$router.push({
              name: "signin",
              query: {
                redirect: that.$router.currentRoute.fullPath,
              },
            });
        }).catch(()=>{

        })
        
        return false;
      }
      this.$router.push({
        // path:'/bidapply',
        path:'/bidetails',
        query:{
          id:id
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.w {
  position: relative;
}

.content {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  padding-bottom: 60px;
  box-sizing: border-box;

  .index-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.back-top {
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  text-align: center;
  z-index: 9999;
  visibility: hidden;
  opacity: 0;
  transition: 1s;
  background: #121212;
  color: #ffffff;
  border-radius: 3px;
  padding: 12px;
  right: 20px;
  bottom: 45px;
}
.back-top.active {
  visibility: visible;
  opacity: 1;
  transition: 0.3s;
}
.floor {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  margin-left: 620px;
  width: 50px;
  background: #fff;
  padding: 0 11px;
  box-sizing: border-box;
  border-radius: 8px;
  z-index: 100;

  .floor-item {
    cursor: pointer;
    padding: 10px 0;
    box-sizing: border-box;
    width: 28px;
    // height: 40px;
    font-size: 14px;
    line-height: 20px;

    + .floor-item {
      border-top: 1px solid #ebebeb;
    }

    &:hover {
      color: #ff0e25;
    }
  }
  .floor-item.active {
    color: #ff0e25;
  }
}
.invitation {
  // margin: 0 12px;
  width: 790px;
  margin-top: 20px;
  border-radius: 5px;
  background: #fff;
  .invitation_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15px;
    padding: 12px 0;
    .invitation_title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
    }
    .invitation_more {
      background: linear-gradient(270deg, #ff0e25 0%, #ff9010 100%);
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      // margin-left: auto;
      padding: 5px 10px;
      cursor: pointer;
    }
  }
  .bidtable {
    .project {
      cursor: pointer;
      .project_head {
        display: flex;
        align-items: center;
        .gongshi {
          padding: 0 6px;
          background: #f0f5ff;
          border-radius: 3px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4177e3;
          line-height: 20px;
        }
        .title {
          margin-left: 6px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          flex: 1;
        }
      }
      .label {
        margin-top: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          &::after {
            content: "、";
          }
        }
        span:last-child {
          &::after {
            content: "";
          }
        }
      }
    }

    .cutoff {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #dd2727;
        line-height: 20px;
      }
    }
    .handle {
      cursor: pointer;
    }
    .look {
      margin-left: 10px;
    }
  }
}
</style>
